module.exports = __webpack_public_path__ + "358dce38613e93e0351fe4f6117f0a07.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/action-icons/minutes.png
// module id = 1549
// module chunks = 0